import { Form, Input, Modal, Row } from 'antd';
import PhoneInput from '@/components/phone-input';
import { useEffect } from 'react';
import Select from '@/components/select';
import { useAddCaseWorkersMutation } from '@/services/general-api';

const AddModal = ({ suffixData, open, refetch, onClose }) => {
  const [addCaseWorkers, { isLoading: adding }] = useAddCaseWorkersMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (body) => {
    try {
      await addCaseWorkers({ ...body, personId: null });
      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <>
      <Modal
        title={'QUICK ADD'}
        open={open}
        okText={'Add'}
        confirmLoading={adding}
        onOk={() => form.submit()}
        onCancel={onClose}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row>
            <Form.Item name={['name', 'first']} label="First Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Row>
          <Row>
            <Form.Item name={['name', 'last']} label="Last Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Row>
          <Row>
            <Form.Item name={['name', 'suffix']} label="Suffix">
              <Select options={suffixData} valueName="code" allowClear />
            </Form.Item>
          </Row>
          <Row>
            <Form.Item name="emailAddress" label="Email" rules={[{ type: 'email', required: true }]}>
              <Input />
            </Form.Item>
          </Row>
          <Row>
            <Form.Item
              name={['phone', 'number']}
              label={'Phone'}
              rules={[
                {
                  validator: async (_, value) => {
                    if (!value || `${value}`.length === 10) return Promise.resolve();
                    return Promise.reject('Invalid phone number');
                  },
                  required: true,
                },
              ]}
            >
              <PhoneInput />
            </Form.Item>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddModal;
